/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RedemptionAccount": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isDefault": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "squareSavings": {
                        "type": ".squareup.corporate_card.resources.rewards.SquareSavingsAccount",
                        "id": 3
                      }
                    },
                    "nested": {
                      "account_details": {
                        "oneof": ["squareSavings"]
                      }
                    }
                  },
                  "SquareSavingsAccount": {
                    "fields": {
                      "accountNumberSuffix": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balanceAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RedemptionAccount && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.SquareSavingsAccount) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Account that rewards can be redeemed into
 * --
 *
 * SOURCE RedemptionAccount @ squareup/corporate_card/resources/rewards/redemption_account.proto at 10:1
 */
export const RedemptionAccount = $root.lookupType('squareup.corporate_card.resources.rewards.RedemptionAccount');
fixType(RedemptionAccount);
Builder.createAndAttachToType(RedemptionAccount);
/**
 * --
 * @desc Square Savings account details
 * --
 *
 * SOURCE SquareSavingsAccount @ squareup/corporate_card/resources/rewards/redemption_account.proto at 42:1
 */
export const SquareSavingsAccount = $root.lookupType('squareup.corporate_card.resources.rewards.SquareSavingsAccount');
fixType(SquareSavingsAccount);
Builder.createAndAttachToType(SquareSavingsAccount);